export default "__VITE_ASSET__to1iOzgT__"